<div
  v-if="shouldRenderConfig && getFactsheet"
  v-bind:class="getClassName"
  class="matrix_table"
>
  <div
    v-bind:class="getClassNameContainer"
    v-for="(value, prodPartCode) in getFactsheet"
    v-bind:key="prodPartCode"
  >
    <div v-bind:class="getClassName + 'Header'">{{value.name}}</div>
    <div
      v-bind:class="getClassNameItem"
      v-for="(fileData, fileKey) in value.files"
    >
      <a
        v-bind:href="fileData.path"
        target="_blank"
        v-bind:title="fileData.name"
        >{{ fileData.name }}</a
      >
    </div>
  </div>
</div>
